import React from 'react';
import SectionHeader from '../ui/SectionHeader';
import Reveal from '../ui/Reveal';
import faq from '../../data/faq.json';
import './FAQ.css';

const GROUPS = [
  { key: 'brands', label: 'For Brands', items: faq.brands },
  { key: 'creators', label: 'For Creators', items: faq.creators },
];

const FAQ = () => {
  return (
    <section className="faq tra-section" id="faq">
      <div className="tra-container">
        <SectionHeader
          eyebrow="FAQ"
          title="Answers for brands and creators"
          subtitle="Everything you need to know before working with us — from both sides of the partnership."
          align="center"
        />

        <div className="faq__columns">
          {GROUPS.map((group, gi) => (
            <Reveal className="faq__column" key={group.key} delay={gi * 0.1}>
              <h3 className="faq__column-title">{group.label}</h3>
              <div className="faq__list">
                {group.items.map((item, i) => (
                  <details className="faq__item" key={i}>
                    <summary className="faq__question">
                      <span>{item.q}</span>
                      <span className="faq__icon" aria-hidden="true" />
                    </summary>
                    <p className="faq__answer">{item.a}</p>
                  </details>
                ))}
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
